import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TranslationHelpers {

    constructor() {
    }


    collectUniqueStrings(target: any, fields?: { [key: string]: number }) {
        const keysArr = fields && typeof fields === 'object' && !Array.isArray(fields) ? Object.keys(fields) : null;
        const keysFilter = (keysArr && keysArr.length) ? keysArr : null;
        const seen = new Map<string, string>(); // string -> hash
        const result: Array<{ value: string; hash: string }> = [];

        function hashStringLocal(str: string) {
            let hash = 0;
            for (let i = 0; i < str.length; i++) {
                hash = ((hash << 5) - hash) + str.charCodeAt(i);
                hash |= 0; // 32-bit
            }
            return `hash_${Math.abs(hash)}`;
        }

        function traverse(curr: any, keyContext?: string) {
            if (Array.isArray(curr)) {
                for (let i = 0; i < curr.length; i++) {
                    const item = curr[i];
                    if (item !== null && typeof item === 'object') {
                        traverse(item);
                    } else if (typeof item === 'string') {
                        if (!keysFilter || (keyContext && keysFilter.indexOf(keyContext) > -1)) {
                            let hash = seen.get(item);
                            if (!hash) {
                                hash = hashStringLocal(item);
                                seen.set(item, hash);
                                result.push({ value: item, hash });
                            }
                            curr[i] = hash;
                        }
                    }
                }
                return;
            }

            if (curr !== null && typeof curr === 'object') {
                for (const key in curr) {
                    const value = curr[key];
                    if (typeof value === 'string') {
                        if (!keysFilter || keysFilter.indexOf(key) > -1) {
                            let hash = seen.get(value);
                            if (!hash) {
                                hash = hashStringLocal(value);
                                seen.set(value, hash);
                                result.push({ value, hash });
                            }
                            curr[key] = hash;
                        }
                    } else if (Array.isArray(value)) {
                        if (!keysFilter || keysFilter.indexOf(key) > -1) {
                            traverse(value, key);
                        } else {
                            traverse(value);
                        }
                    } else {
                        traverse(value);
                    }
                }
            }
        }

        traverse(target);
        return result;
    }


    restoreOriginalStrings(obj: any, collected: { value: string; hash: string; }[], fields?: { [key: string]: number }) {
        const hashToValue = new Map<string, string>();
        for (const { value, hash } of collected) {
            hashToValue.set(hash, value);
        }

        const keysArr = fields && typeof fields === 'object' && !Array.isArray(fields) ? Object.keys(fields) : null;
        const keysFilter = (keysArr && keysArr.length) ? keysArr : null;

        function traverse(curr: any, keyContext?: string) {
            if (Array.isArray(curr)) {
                for (let i = 0; i < curr.length; i++) {
                    const v = curr[i];
                    if (typeof v === 'string' && hashToValue.has(v)) {
                        if (!keysFilter || (keyContext && keysFilter.indexOf(keyContext) > -1)) {
                            curr[i] = hashToValue.get(v);
                        }
                    } else {
                        traverse(v);
                    }
                }
                return;
            }

            if (curr !== null && typeof curr === 'object') {
                for (const key in curr) {
                    const v = curr[key];
                    if (typeof v === 'string' && hashToValue.has(v)) {
                        if (!keysFilter || keysFilter.indexOf(key) > -1) {
                            curr[key] = hashToValue.get(v);
                        }
                    } else if (Array.isArray(v)) {
                        if (!keysFilter || keysFilter.indexOf(key) > -1) {
                            traverse(v, key);
                        } else {
                            traverse(v);
                        }
                    } else {
                        traverse(v);
                    }
                }
            }
        }

        traverse(obj);
        return obj;
    }
}
